
import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'BaseChuiGaki',

  props: {
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  },

  methods: {
  },
})
